/**
 * Lazy mega-menu trek cards (images + distance/grade). Cached after first open.
 */
export function useMenuTreks() {
  const {
    data: menuTreks,
    pending,
    execute,
    status,
  } = useLazyFetch<Array<Record<string, unknown>>>("/api/menu-treks", {
    key: "menu-treks",
    immediate: false,
    server: false,
  });

  async function ensureMenuTreks() {
    if (menuTreks.value?.length) return;
    if (status.value === "pending") return;
    await execute();
  }

  return { menuTreks, pending, ensureMenuTreks };
}
